// Every base URL below is read straight from environment variables, with no
// hardcoded fallback host. Vercel scopes each of these vars per deployment
// environment (Production / Preview / Development), so pointing a build at
// prod vs. qa is a Vercel project-settings change, not a code change.

//..... api link for backend.....//
const api = process.env.REACT_APP_APIKEY

const token = process.env.REACT_APP_TOKEN

//..... api link for ai backend.....///
const ai_api = process.env.REACT_APP_PROD_AI_APIKEY

const strapiUrl = process.env.REACT_APP_STRAPI_URL || 'http://localhost:1337'

//..... blog is served from the same backend as the main api.....//
const blogApiUrl = api

//..... api link for okara (AI CMO) backend.....//
const okara_api = process.env.REACT_APP_OKARA_APIKEY

export { api, token, ai_api, strapiUrl, blogApiUrl, okara_api }
